// extracted by mini-css-extract-plugin
export default {"LogoLoading":"style_LogoLoading__6bh6K","navy":"style_navy__HLZoc","logo":"style_logo__F6AXX","heartbeat":"style_heartbeat__8770r"};